module.exports = "/static/assets/c6512c99c2c300e1ed16dfc63d514d17.png";